module.exports = __webpack_public_path__ + "img/coup13.2417517c.png";